module.exports = __webpack_public_path__ + "assets/img/changeJourneyD4.1896e604.png";